/**
 * RepuCall - Application Entry Point
 *
 * This is the main entry point that bootstraps the React application.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './index.css';
import App from './App';

// Initialize Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0.1,
  });
}

// Initialize PostHog
const posthogToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
if (posthogToken && import.meta.env.PROD) {
  posthog.init(posthogToken, {
    api_host: posthogHost || 'https://us.i.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
}

// Log application startup
console.info(
  '%c[RepuCall] Application starting...',
  'color: #1F497D; font-weight: bold; font-size: 14px;'
);

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('[RepuCall] Root element not found! Application cannot start.');
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

console.info(
  '%c[RepuCall] Application mounted successfully',
  'color: #2BBF6A; font-weight: bold;'
);
